

































import { Component, Prop, Vue } from 'vue-property-decorator';
import urlHelperService from '@/services/url/urlHelper.service';
import { TDirectory, TFile } from '@/types/apiServerContract';

@Component
export default class FilePicker extends Vue {
    @Prop({ required: true, type: Array, default: () => [] })
    directories!: TDirectory[];

    @Prop({ required: true })
    value!: TFile | TFile[] | null;

    @Prop({ required: false, type: Boolean, default: false })
    canSelectFolder!: boolean;

    @Prop({ required: false, type: Boolean, default: false })
    canCreateFolder!: boolean;

    @Prop({ required: false, type: Boolean, default: false })
    canCreateFiles!: boolean;

    @Prop({ required: false, type: Boolean, default: false })
    useUrlQuery!: boolean;

    initialized: boolean = false;

    get desc() {
        return Array.isArray(this.value) ? this.value.length : this.value ? this.value.name : null;
    }

    selectFiles(files: TFile[]) {
        if (Array.isArray(this.value)) {
	        const newValue = [...this.value];

            for (const file of files) {
                const index = this.value.findIndex(x => x.fullPath === file.fullPath);
                if (index < 0) {
                    newValue.push(file);
                } else {
                    newValue.splice(index, 1);
                }
            }

	        this.$emit('input', newValue);
	    } else {
            if (this.useUrlQuery) {
                urlHelperService.setQueryParam('selectedFile', files[0].fullPath);
            }

            this.$emit('input', files[0]);
	    }

        this.hideFileSelector();
    }

    createFolder(folderPath: string) {
        this.$emit('create-folder', folderPath);
    }

    createFile(filePath: string) {
        this.$emit('create-file', filePath);
    }

    filePickerActive: boolean = false;

    showFileSelector() {
        this.filePickerActive = true;

        if (!this.initialized) {
            if (!!this.value && typeof this.value === 'object') {
                this.$nextTick(() => {
                    const fileElement = document.getElementById((this.value as TFile).fullPath);
                    if (fileElement) {
                        const overlay = this.$refs.overlay;

                        const fileRect = fileElement.getBoundingClientRect();
                        const overRect = overlay.getBoundingClientRect();

                        const scrollTop = (fileRect.top - overRect.top + overlay.scrollTop);

                        overlay.scrollTop = scrollTop;
                    }
                });
            }

            this.initialized = true;
        }
    }

    hideFileSelector() {
        this.filePickerActive = false;
    }

    selectActiveFileFromUrl() {
        const file = urlHelperService.getQueryParam('selectedFile') as string;
        if (file) {
            const paths = file.replace(/\\/g, '/').split('/').filter(x => !!x);
            const selectedFile = selectFile(this.directories, paths, paths[0], file);
            if (selectedFile) {
                this.selectFiles([selectedFile]);
            }
        }

        function selectFile(directories: TDirectory[], filePaths: string[], currentPath: string, filePath: string): TFile | null {
            for (const directory of directories) {
                if (directory.name === currentPath) {
                    if (directory.files.length) {
                        const file = directory.files.find(x => x.fullPath === filePath);
                        if (file) {
                            return file;
                        }
                    }

                    const index = filePaths.indexOf(currentPath);
                    const nextDir = filePaths[index + 1];

                    return selectFile(directory.children, filePaths, nextDir, filePath);
                }
            }

            return null;
        }
    }

    created() {
        this.selectActiveFileFromUrl();
    }

    openAll() {
        if (Array.isArray(this.$refs.directory)) {
            for (const directory of this.$refs.directory) {
                directory.open(true);
            }
        } else if (this.$refs.directory) {
            (this.$refs.directory as any).open();
        }
    }

    closeAll() {
        if (Array.isArray(this.$refs.directory)) {
            for (const directory of this.$refs.directory) {
                directory.close(true);
            }
        } else if (this.$refs.directory) {
            (this.$refs.directory as any).close();
        }
    }

    public $refs!: {
        overlay: HTMLElement;
        directory: any[];
    }
}
